import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { md } from '../../../../../utils/breakpoints';
import t from '../../../../../utils/i18n';
import { mapStateToProps } from '../../../../../utils/mapper';
import { colors } from '../../../../../utils/styles';
import ExternalLink from '../../../../external_link';

import { Link } from '../../../../../modules/routing';

interface MenuItemProps {
    external?: boolean;
    title: string;
    url?: string;
    catcherPress?: () => void;
    window: { width: number, multiplier: number };
    test?: boolean;
};

const styles = {
    mainMenuItem: RX.Styles.createViewStyle({
        backgroundColor: colors.background,
    }),
};

export class MenuItem extends RX.Component<MenuItemProps, RX.CommonProps & { width: number }> {

    constructor(props: MenuItemProps) {
        super(props);
        this.state = { width: 0 };
    }

    public render() {
        const { title, url = '', external, window: { width, multiplier }, catcherPress, test } = this.props;
        return (
            <RX.View
                style={[
                    styles.mainMenuItem,
                    width < md
                        ? { width }
                        : {
                            backgroundColor: colors.background,
                            borderBottomWidth: 0,
                            borderColor: colors.white,
                            borderLeftWidth: 0,
                            borderRightWidth: 1 * multiplier,
                            borderTopWidth: 0,
                            justifyContent: 'center',
                            minWidth: 10 * multiplier,
                            padding: 8 * multiplier,
                        }
                ]}
            >
                {external ?
                    <ExternalLink test isMenu text={title} destination={url} locText={t('external.scheduling')} /> :
                    !test ? <Link
                        onClick={catcherPress}
                        style={{
                            height: 40 * multiplier,
                            paddingBottom: 8 * multiplier,
                            paddingTop: 8 * multiplier,
                            textDecoration: 'none',
                        }}
                        to={url}
                    >
                        <RX.Text style={{
                            color: 'red',
                            fontSize: 18 * multiplier,
                            fontWeight: '400',
                        }}>{title}</RX.Text>
                    </Link> : <a
                        onClick={catcherPress}
                        style={{
                            height: 40 * multiplier,
                            paddingBottom: 8 * multiplier,
                            paddingTop: 8 * multiplier,
                            textDecoration: 'none'
                        }}
                        href={url}
                    >
                            <RX.Text style={{
                                color: '#0059A3',
                                fontSize: 18 * multiplier,
                                fontWeight: '400',
                            }}>{title}</RX.Text>
                        </a>
                }
            </RX.View>
        );
    };
}

export default connect(mapStateToProps)(MenuItem);



// WEBPACK FOOTER //
// ./src/components/menu/menu_container/menu_section/menu_item/index.tsx